import { makeStyles } from '@mui/styles';
import { colors } from '../../packages';

export const useStyles = makeStyles({
  drawer: {
    '& .MuiPaper-root': {
      maxWidth: '1000px !important',
      backgroundColor: colors.neutral50,
    },
  },
});
